// Server addresses per environment — the SAME file on `staging` and `master`.
//
// Do not hardcode URLs here any more: the table lives in environments.mjs and the
// environment is picked at build/run time (VITE_ODS_ENV, VITE_SENTRY_ENVIRONMENT,
// `vite --mode`, then the page hostname). Local dev on localhost talks to the local
// backend automatically; no need to edit this file before/after testing.
// To point a build at another backend, set VITE_ODS_BASE_URL / VITE_ODS_WS_LINK.
import { resolveEnvironment } from './environments.mjs';

// Each variable is read by name so Vite inlines only these (not the whole env object).
const resolved = resolveEnvironment({
  env: {
    VITE_ODS_ENV: import.meta.env.VITE_ODS_ENV,
    VITE_ODS_BASE_URL: import.meta.env.VITE_ODS_BASE_URL,
    VITE_ODS_WS_LINK: import.meta.env.VITE_ODS_WS_LINK,
    VITE_SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    MODE: import.meta.env.MODE,
    DEV: import.meta.env.DEV,
  },
  hostname: typeof window !== 'undefined' ? window.location.hostname : '',
});

/** 'production' | 'staging' | 'local' — which backend this bundle talks to. */
export const ODS_ENV = resolved.env;
export const BASE_URL = resolved.BASE_URL;
export const WS_LINK = resolved.WS_LINK;

export const RESTAURANT_ID = '7'
export const CHATGPT_API_KEY = import.meta.env.VITE_CHATGPT_API_KEY
